export default "__VITE_ASSET__CQIMDQ$2__"